import React, { useEffect, useState, useRef } from 'react';
import axios from 'lib/axios';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import Avatar from '../../assets/images/users/avatar-1.png';
import CompanyIcon from '../../assets/static_images/company.svg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import VoiceViewer from 'components/modals/VoiceViewer';
import { Box, Paper } from '@mui/material';
import UserAvatarComponent from 'components/UserAvatarComponent';
import RightSideSkeleton from 'components/skeleton/RightSideSkeleton';
import { socket } from 'socket';
import ViewPolicyModal from './ViewPolicyModal';
import MiniPolicyBody from './MiniPolicyBody';

const TopPolicies = () => {
    const [oepnViewer, setOpenViewer] = useState(false);
    const [selected, setSelected] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(5);
    const [offset, setOffset] = useState(0);
    const [policies, setPolicies] = useState([]);

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    useEffect(() => {
        const formData = new FormData();
        formData.append('company_id', JSON.parse(window.localStorage.getItem('authUser'))?.company_id);
        formData.append('offset', offset);
        formData.append('limit', limit);
        setIsLoading(true);
        axios
            .post('/policies/most-liked', formData)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.policies.length > 0) {
                    setPolicies((prev) => [...prev, ...data.policies]);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }, [offset, limit]);

    useEffect(() => {
        listen_to_channel();
    }, []);
    function listen_to_channel() {
        socket.on('policy_added', (policy) => {
            if (policy) {
                setPolicies((prev) => [policy, ...prev]);
            }
        });

        socket.on('policy_removed', (policy) => {
            if (policy) {
                setPolicies((prev) => prev.filter((item) => item.policy_id !== policy.policy_id));
            }
        });
    }

    console.log('policies', policies);

    return (
        <Grid sm={12} container>
            <Grid item sm={12} display="flex" alignItems="center" sx={{ paddingX: '0px', width: '100%' }}>
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: { md: '16px', xs: '0px' },
                        height: { md: 'calc(100vh - 7.5rem)', xs: 'calc(100vh - .5rem)' },
                        overflowY: 'auto',
                        border: '1px solid #1E7C8840',
                        borderRadius: '8px',
                        backgroundColor: '#ffffff',
                        width: '100%'
                    }}
                >
                    <CardContent sx={{ padding: '24px 0px' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '0 24px 20px',
                                borderBottom: '1px solid rgba(30, 124, 136, 0.08)',
                                marginBottom: '20px'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '8px',
                                    backgroundColor: 'rgba(30, 124, 136, 0.08)'
                                }}
                            >
                                <img src={CompanyIcon} alt="icon" style={{ width: '18px', height: '18px' }} />
                            </Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#1E7C88',
                                    letterSpacing: '-0.02em'
                                }}
                            >
                                Top Liked Policies
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '0 24px' }}>
                            {isLoading
                                ? Array.from({ length: 10 }, (_, index) => <RightSideSkeleton key={index} />)
                                : policies.map((item, index) => <MiniPolicyBody key={`policy-${index}`} item={item} />)}

                            {policies.length > 5 ? (
                                <Box display="flex" justifyContent="center" sx={{ marginTop: '24px', marginBottom: '16px' }}>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            borderRadius: '12px',
                                            textTransform: 'none',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            padding: '8px 24px',
                                            borderColor: '#1E7C88',
                                            color: '#1E7C88',
                                            '&:hover': {
                                                backgroundColor: 'rgba(30, 124, 136, 0.04)',
                                                borderColor: '#1E7C88'
                                            }
                                        }}
                                        onClick={() => {
                                            setPolicies([]);
                                            setOffset(0);
                                        }}
                                    >
                                        View Less
                                    </Button>
                                </Box>
                            ) : (
                                policies.length === 5 && (
                                    <Box display="flex" justifyContent="center" sx={{ marginTop: '24px', marginBottom: '16px' }}>
                                        <Button
                                            variant="contained"
                                            sx={{
                                                borderRadius: '12px',
                                                textTransform: 'none',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                padding: '8px 24px',
                                                backgroundColor: '#1E7C88',
                                                '&:hover': {
                                                    backgroundColor: '#156a73'
                                                }
                                            }}
                                            onClick={() => {
                                                setOffset((prev) => prev + limit);
                                            }}
                                        >
                                            View More
                                        </Button>
                                    </Box>
                                )
                            )}
                        </Box>
                    </CardContent>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default TopPolicies;
